import cloneDeep from "lodash/cloneDeep";
import {
  arboretumBlueprint,
  constellationBlueprint,
  treeBlueprint,
} from "./blueprint";
import { applySlotsToQuadrants, applyRotationAndTerminus } from "./utils";

export const getArboretum = (trees = []) => {
  const tree = cloneDeep(arboretumBlueprint);
  const slotIds = new Set(
    trees.filter((tree) => tree.terminusActive).map((tree) => tree.id),
  );
  applySlotsToQuadrants(tree.quadrants, slotIds, false);
  if (!tree.quadrants.find((q) => !q.disabled)) {
    // Enabled source by default
    tree.quadrants.find((q) => q.id === "source").disabled = false;
  }
  return tree;
};

export const getConstellation = (slots = []) => {
  const tree = cloneDeep(constellationBlueprint);
  const slotIds = new Set(slots.map((s) => s.glyphId));
  applySlotsToQuadrants(tree.quadrants, slotIds);
  return tree;
};

export const getTree = (treeId, slots = []) => {
  const blueprint = treeBlueprint.find((t) => t.id === treeId);
  if (!blueprint) {
    return null;
  }

  const tree = cloneDeep(blueprint);
  const slotIds = new Set(slots.map((s) => s.quadrantId));
  applySlotsToQuadrants(tree.quadrants, slotIds);

  if (!slotIds.has("source")) {
    tree.quadrants.find((q) => q.id === "source").disabled = false;
  }

  const constellation = getConstellation(slots);
  const assigned = [];
  slots.forEach((slot) => {
    const q = tree.quadrants.find((q) => q.id === slot.quadrantId);
    if (!q) {
      return;
    }
    const glyphQ = constellation.quadrants.find((g) => g.id === slot.glyphId);
    Object.assign(q, {
      glyphId: glyphQ.id,
      displayName: glyphQ.displayName,
      backgroundColor: glyphQ.backgroundColor,
    });
    assigned.push(q);
  });

  applyRotationAndTerminus(tree, assigned);
  return tree;
};
